"use server"

import { sdk } from "@lib/config"
import { HttpTypes } from "@medusajs/types"
import { getAuthHeaders, getCacheOptions } from "./cookies"

export const listCartShippingMethods = async (cartId: string) => {
  const headers = {
    ...(await getAuthHeaders()),
  }

  const next = {
    ...(await getCacheOptions("fulfillment")),
  }

  return sdk.client
    .fetch<HttpTypes.StoreShippingOptionListResponse>(
      `/store/shipping-options`,
      {
        method: "GET",
        query: {
          cart_id: cartId,
        },
        headers,
        next,
        cache: "force-cache",
      }
    )
    .then(({ shipping_options }) => shipping_options)
    .catch(() => {
      return null
    })
}

export type ShippingPreviewOption = {
  id: string
  name: string
  description: string | null
  amount: number
  currency_code: string
}

export type ShippingPreview = {
  country_code: string
  ships_from_country_code: string | null
  ships_from_city: string | null
  currency_code: string
  shipping_options: ShippingPreviewOption[]
}

/**
 * Previews shipping methods and prices for a country without needing a cart.
 * Used by the PDP "Shipping Method" widget to let shoppers check rates
 * before adding to cart.
 */
export const getShippingPreview = async (
  countryCode: string
): Promise<ShippingPreview | null> => {
  const next = {
    ...(await getCacheOptions("fulfillment")),
  }

  return sdk.client
    .fetch<ShippingPreview>("/store/shipping-preview", {
      method: "GET",
      query: { country_code: countryCode },
      next,
      cache: "force-cache",
    })
    .catch(() => null)
}

export const calculatePriceForShippingOption = async (
  optionId: string,
  cartId: string,
  data?: Record<string, unknown>
) => {
  const headers = {
    ...(await getAuthHeaders()),
  }

  const next = {
    ...(await getCacheOptions("fulfillment")),
  }

  const body = { cart_id: cartId, data }

  if (data) {
    body.data = data
  }

  return sdk.client
    .fetch<{ shipping_option: HttpTypes.StoreCartShippingOption }>(
      `/store/shipping-options/${optionId}/calculate`,
      {
        method: "POST",
        body,
        headers,
        next,
      }
    )
    .then(({ shipping_option }) => shipping_option)
    .catch((e) => {
      return null
    })
}
